<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../library/scripts/styles'
	import { delete_content } from '../library/scripts/utils.js'
	import {
		storeUploader,
		storeActiveBlock,
		storeUpdate,
		storeFinishedContent,
		storeShowFinishedBlocks,
		storeLogo,
		storeData,
		storeShowCreateButtons,
		storeLinked,
	} from '../library/scripts/Store.svelte'
	import { url } from '../library/scripts/Setup.svelte'
	import FileUploader from '../library/FileUploader.svelte'
	import DropFiles from '../library/LayoutStuff/DropFiles.svelte'
	import SingleCol from '../library/columLayouts/SingleCol.svelte'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../modals/Alert.svelte'

	export let blockName = null
	export let maxContent = 1

	let configFile
	const stoData = storeData.subscribe((value) => {
		configFile = value
	})

	const stoActiveBl = storeActiveBlock.subscribe((value) => {
		blockName = value
	})

	//is this an update
	let isUpdate = false
	const stoUpdt = storeUpdate.subscribe((value) => {
		isUpdate = value
	})
	let hasLogo
	const stoLogo = storeLogo.subscribe((value) => {
		if (value) hasLogo = false
		else hasLogo = true
	})
	let closeUpdate = false
	let uploadCmd = 'upload'

	//the images array to send to File Uploader
	let uploadImage = []

	const globals = getContext('globals')
	const colorMain = globals.adminColorMain
	const fsN = globals.fsN
	const fsS = globals.fsS
	const fsL = globals.fsL
	const fsXS = globals.fsXS
	const inputBg = globals.adminInputBg
	const buttonBgHover = globals.adminButtonBgHover

	let showCreateContent = false
	let dropFiles = false

	let selectedID = null
	let idCounter = 1
	let deleteBlock = false
	let showSave = false

	//timeouts
	let toWait

	//the accepted files
	const acceptedFiles = ['image/jpg', 'image/jpeg', 'image/png']

	//only one image per slide
	let showError = false

	//error message
	let message = ''
	let showOkButton = false

	let uploadFiles
	const stoUp = storeUploader.subscribe((value) => {
		uploadFiles = value
	})

	//columns
	let columnArray = []

	//preview images
	let PREVHEIGHT = 80
	let PREVWIDTH = 60
	let PREVLANDSCAPE = 120

	//update
	$: if (isUpdate) {
		closeUpdate = true
		storeShowCreateButtons.set(false)
		storeActiveBlock.set(blockName)
		uploadCmd = 'update'
		deleteBlock = true
		if (configFile.logo) {
			showCreateContent = true
			let col = document.createElement('div')
			col.setAttribute('id', 'col_' + configFile.logo.id)
			col.style.cursor = 'pointer'
			col.style.display = 'flex'
			col.style.flexDirection = 'column'
			col.style.alignItems = 'center'
			col.style.justifyContent = 'center'
			col.style.width = '100%'
			col.style.height = 'max(150px,min(15vmax, 230px)'
			col.style.height = 'clamp(150px,15vw, 230px)'
			col.style.background = inputBg
			col.style.marginRight = '5px'
			col.addEventListener('click', update_content)

			let colImage = document.createElement('div')
			colImage.setAttribute('id', 'image_' + configFile.logo.id)
			colImage.style.marginTop = '5px'

			//add the image
			if (configFile.logo.image) {
				const imageFile = url + '/' + blockName + '/thumbnail/' + configFile.logo.image

				let image = new Image()
				image.src = imageFile
				image.onload = () => {
					let canvas = document.createElement('canvas')
					canvas.setAttribute('id', 'canv_' + configFile.logo.id)
					let ctx = canvas.getContext('2d')

					if (image.width > image.height) {
						canvas.height = PREVHEIGHT
						canvas.width = PREVLANDSCAPE
					}

					if (image.width < image.height) {
						canvas.height = PREVHEIGHT
						canvas.width = PREVWIDTH
					}

					if (image.width === image.height) {
						canvas.height = PREVHEIGHT
						canvas.width = PREVHEIGHT
					}
					ctx.drawImage(image, 0, 0, canvas.width, canvas.height)
					colImage.append(canvas)
					col.append(colImage)
				}
			}

			toWait = setTimeout(() => {
				const preview = document.querySelector('#createContent')
				preview.append(col)
				storeUpdate.set(false)
				storeShowFinishedBlocks.set(false)
				showSave = true
			}, 1)
		}
	}

	//responsive
	$: if (window.innerWidth < 569) {
		PREVHEIGHT = 40
		PREVWIDTH = 13.5
		PREVLANDSCAPE = 60
	}

	$: if (window.innerWidth > 569) {
		PREVHEIGHT = 80
		PREVWIDTH = 60
		PREVLANDSCAPE = 120
	}

	//promisses
	let uploader = upload_block()

	//functions

	const create_column_id = () => {
		if (columnArray.length + 1 > maxContent) {
			showError = true
			message = `maximal ${maxContent} logo per site!`
			return
		}
		showCreateContent = true
		selectedID = null

		//wait for preview to be loaded
		toWait = setTimeout(() => {
			storeShowFinishedBlocks.set(false)
			idCounter = columnArray.length + 1
			create_column(idCounter)
		}, 1)
	}

	const create_column = (id) => {
		//add link if columnArray is empty

		let col = document.createElement('div')
		col.setAttribute('id', 'col_' + id)
		col.style.cursor = 'pointer'
		col.style.display = 'flex'
		col.style.flexDirection = 'column'
		col.style.alignItems = 'center'
		col.style.justifyContent = 'center'
		col.style.width = '100%'
		col.style.height = '100%'
		col.style.background = inputBg
		col.style.marginRight = '5px'

		//the create text link
		let colLink = document.createElement('div')
		colLink.setAttribute('id', 'link_1')
		colLink.style.display = 'flex'
		colLink.style.width = '100%'
		colLink.style.height = '100%'
		colLink.style.justifyContent = 'center'
		colLink.style.alignItems = 'center'
		colLink.innerText = 'click to create content'
		colLink.style.fontSize = fsS

		let colImage = document.createElement('div')
		colImage.setAttribute('id', 'image_' + id)
		colImage.style.marginTop = '5px'

		col.addEventListener('click', add_content)
		col.append(colLink)
		col.append(colImage)
		let createContent = document.querySelector('#createContent')
		createContent.append(col)
		columnArray.push({
			id: id,
			// css
			//image *** IMPORTANT*** !!!!!image MUST be on top of list!!!!!!
			image: null,
			imageHeight: 53,
			objectFit: 'cover',
			backgroundColor: 'hsla(0,0%,100%,0)',
			top: 0,
			left: 0,
		})
	}

	const update_content = (e) => {
		selectedID = parseInt(e.target.id.split('_')[1])
		const link = document.querySelector('#link_' + selectedID)
		if (link) link.remove()

		//add link if columnArray is empty
		columnArray.forEach((item) => {
			if (
				selectedID !== configFile.logo.id &&
				!configFile.logo.image &&
				!item.title &&
				!item.text &&
				!document.querySelector('#link_1')
			) {
				const col = document.querySelector('#col_1')
				let colLink = document.createElement('div')
				colLink.setAttribute('id', 'link_' + configFile.logo.id)
				colLink.style.display = 'flex'
				colLink.style.width = '100%'
				colLink.style.height = '100%'
				colLink.style.justifyContent = 'center'
				colLink.style.alignItems = 'center'
				colLink.innerText = 'click to create content'
				colLink.style.fontSize = fsS
				col.prepend(colLink)
			}
		})

		//check if has image
		const image = document.querySelector('#image_' + selectedID)
		if (image) {
			if (image.childNodes.length < 1) dropFiles = true
			else {
				dropFiles = false
			}
		}
	}

	const add_content = (element) => {
		const colID = element.target.parentElement.id
		const id = parseInt(colID.split('_')[1])

		//remove the click info
		document.querySelector('#link_1').remove()

		showSave = true

		if (document.querySelector('#link_1')) {
			const col = document.querySelector('#col_1')
			let colLink = document.createElement('div')
			colLink.setAttribute('id', 'link_1')
			colLink.style.display = 'flex'
			colLink.style.width = '100%'
			colLink.style.height = '100%'
			colLink.style.justifyContent = 'center'
			colLink.style.alignItems = 'center'
			colLink.innerText = 'click to create content'
			colLink.style.fontSize = fsS
			col.prepend(colLink)
		}

		const preview = document.querySelector('#createContent')

		for (let key in preview.children) {
			if (preview.children[key].id === colID) {
				preview.children[key].removeEventListener('click', add_content)
				preview.children[key].addEventListener('click', update_content)
				selectedID = parseInt(key) + 1
			}
		}

		if (columnArray[selectedID - 1].image) {
			dropFiles = false
			return
		}

		//show delete button if image is set but not yet saved
		const del = document.querySelector('#canv_' + selectedID)
		if (del) {
			dropFiles = false
			return
		}

		dropFiles = true
	}

	const save_block = () => {
		//error handling
		let error = false

		//user did save without adding a new logo
		if (uploadImage.length === 0) {
			showError = true
			error = true
			message = 'plaese add a new logo'
		}

		if (error) return
		if (closeUpdate) uploadCmd = 'update'
		uploadFiles = true
		storeUploader.set(true)
		uploader = upload_block()
		selectedID = null
		showSave = false
		showCreateContent = false
		storeLogo.set(false)
		storeShowFinishedBlocks.set(true)
		reset_all()
	}

	async function upload_block() {
		return uploadImage
	}

	const create_preview_image = (image) => {
		let imageFile = image
		let colImage = document.querySelector('#image_' + selectedID)
		let colCanv = document.querySelector('#canv_' + selectedID)

		if (!colImage) {
			const col = document.querySelector('#col_' + selectedID)
			colImage = document.createElement('div')
			colImage.setAttribute('id', 'image_' + selectedID)
			colImage.style.marginTop = '5px'
			col.append(colImage)
		}

		let reader = new FileReader()
		reader.readAsDataURL(imageFile)
		reader.onload = () => {
			let image = new Image()
			image.src = reader.result
			image.onload = () => {
				let canvas = document.createElement('canvas')
				canvas.setAttribute('id', 'canv_' + selectedID)
				let ctx = canvas.getContext('2d')

				if (image.width > image.height) {
					canvas.height = PREVHEIGHT
					canvas.width = PREVLANDSCAPE
				}

				if (image.width < image.height) {
					canvas.height = PREVHEIGHT
					canvas.width = PREVWIDTH
				}

				if (image.width === image.height) {
					canvas.height = PREVHEIGHT
					canvas.width = PREVHEIGHT
				}
				ctx.drawImage(image, 0, 0, canvas.width, canvas.height)
				colImage.appendChild(canvas)

				if (!colCanv) {
					colImage.appendChild(canvas)
					dropFiles = false
					return
				}

				colImage.replaceChild(preview, colCanv)
				dropFiles = false
			}
		}
		return ''
	}

	const delete_preview_image = () => {
		const image = document.querySelector('#canv_' + selectedID)
		image.remove()
		dropFiles = true
	}

	//close main window
	const close_window = () => {
		storeShowFinishedBlocks.set(true)
		storeActiveBlock.set(null)
		reset_all()
	}

	//dispatch functions
	const check_file = (e) => {
		if (e.detail.error === 'true') {
			showError = true
			message = 'Sorry, only one logo per site allowed'
			return
		}

		uploadImage = [e.detail.files[0][Object.keys(e.detail.files[0])]]
		create_preview_image(e.detail.files[0][Object.keys(e.detail.files[0])])
	}

	const close_alert = () => {
		showError = false
	}

	const alert_delete = () => {
		showError = true
		message = 'delete logo?'
		showOkButton = true
	}

	const alert_delete_block = async (blockName) => {
		closeUpdate = true
		const remainingBlocks = await delete_content(blockName)

		//show the logo button if the logo block is deleted
		if (blockName === 'logo') storeLogo.set(true)

		if (remainingBlocks) {
			showError = false
			remainingBlocks.sort()
			uploadCmd = 'upload'
			storeFinishedContent.set({ finishedBlocks: remainingBlocks, linkedSites: $storeLinked.linkedSites })
			storeShowFinishedBlocks.set(true)
			storeActiveBlock.set(null)
			reset_all()
		}
	}

	const reset_all = () => {
		columnArray = []
		selectedID = null
		showCreateContent = false
		document.location = '/#/createblock'
		storeUpdate.set(false)
		storeShowCreateButtons.set(true)
		closeUpdate = false
		deleteBlock = false
		showSave = false
		deleteBlock = false
	}

	onDestroy(() => {
		clearTimeout(toWait)
		stoActiveBl
		stoUp
		stoUpdt
		stoLogo
		stoData
	})
</script>

{#if blockName}
	<main id="updateblock" use:styles={{ colorMain, fsN }}>
		<div class="block_title" use:styles={{ fsL, colorMain }}>{blockName}</div>

		<div class="button_container button_left">
			{#if !hasLogo}
				<button use:styles={{ colorMain, fsXS }} on:click={create_column_id}>add logo</button>
			{/if}
		</div>

		{#if showCreateContent}
			<div class="create_content" id="createContent" transition:slide={{ duration: 1000 }} />
		{/if}

		{#if selectedID > 0}
			<section transition:slide={{ duration: 1000 }}>
				<SingleCol>
					<div slot="column1" id="column_1">
						{#if dropFiles}
							<DropFiles on:upload={check_file} filesAccepted={acceptedFiles} allowedImages="1" />
						{:else}
							<button on:click={delete_preview_image} use:styles={{ colorMain, fsXS, buttonBgHover }}
								>delete image</button
							>
						{/if}
					</div>
				</SingleCol>
			</section>
		{/if}
		<div class="button_container">
			<button on:click={close_window} use:styles={{ colorMain, fsXS, buttonBgHover }}>close</button>
			{#if showSave}
				<button on:click={save_block} use:styles={{ colorMain, fsXS, buttonBgHover }}>save</button>
			{/if}
			{#if deleteBlock}
				<button on:click={alert_delete} use:styles={{ colorMain, fsXS, buttonBgHover }}>delete</button>
			{/if}
		</div>
	</main>
{/if}
{#if uploadFiles}
	{#await uploader then upload}
		<FileUploader files={upload} blockTitle="logo" />
	{/await}
{/if}

{#if showError}
	<Shader>
		<div slot="content">
			<Alert {message} {showOkButton} on:alertok={() => alert_delete_block(blockName)} on:alertclose={close_alert} />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: 95vw;
		display: flex;
		flex-direction: column;
		padding: 2%;
		color: var(--colorMain);
		font-size: var(--fsN);
		user-select: none;
	}

	button {
		background-color: transparent;
		color: var(--colorMain);
		border: 1px solid var(--colorMain);
		font-size: var(--fsXS);
		width: clamp(100px, 13vw, 200px);
		margin-left: 1%;
		padding: 1%;
		border-radius: 5px;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonBgHover);
	}

	.block_title {
		color: var(--colorMain);
		font-size: var(--fsL);
		text-transform: uppercase;
		font-weight: bold;
		margin: 20px 0px 20px 0px;
	}

	.button_container {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
		border-top: 1px solid green;
		margin-top: 20px;
		padding-top: 25px;
	}

	.button_left {
		justify-content: flex-start;
	}

	.create_content {
		position: relative;
		display: flex;
		width: 100%;
		height: clamp(150px, 16vw, 250px);
		margin-bottom: 1%;
		align-items: center;
	}
</style>
